import TimelineItem from "./TimelineItem";

export default function Timeline({ items, timelineIcon }) {
  return (
    <ul className="flex list-none flex-col items-start max-[1200px]:pl-[0.4rem]">
      {items?.map((item, index) => (
        <TimelineItem key={index} timelineIcon={timelineIcon} data={item} />
      ))}
    </ul>
  );
}
